// AUTO-GENERATED by scripts/gen-web-labels.mjs — DO NOT EDIT BY HAND.
// Source: src/i18n/locales/*.ftl (the single source of wording for the bot AND the Mini App).
// Regenerated by `npm run build` / `npm run dev:web`; drift-guarded by labels.gen.test.ts.

export const WEB_LABELS: Record<string, Record<string, string>> = {
  "en": {
    "ai-cat-adult": "Adult content",
    "ai-cat-crypto": "Crypto",
    "ai-cat-other": "Other",
    "ai-cat-phishing": "Phishing",
    "ai-cat-promotion": "Promotion",
    "ai-cat-scam": "Scam",
    "ai-cat-solicitation": "Solicitation",
    "cfg-default": "(default)",
    "cfg-f-action": "Action",
    "cfg-f-aibudget": "Daily AI checks",
    "cfg-f-allowlist": "Allowlisted domains",
    "cfg-f-announce": "Announce",
    "cfg-f-blocklist": "Blocklist",
    "cfg-f-channels": "Channel messages",
    "cfg-f-cleanprevious": "Clean previous welcome",
    "cfg-f-deleteafter": "Delete after",
    "cfg-f-enabled": "Status",
    "cfg-f-endhour": "Reopens at",
    "cfg-f-expiry": "Expiry",
    "cfg-f-failaction": "On fail",
    "cfg-f-forwards": "Forwards",
    "cfg-f-goodbyetext": "Goodbye text",
    "cfg-f-invites": "Invite links",
    "cfg-f-joinleave": "Join / leave",
    "cfg-f-jointhreshold": "Join threshold",
    "cfg-f-limit": "Limit",
    "cfg-f-linkpolicy": "Link policy",
    "cfg-f-links": "Links",
    "cfg-f-lockdown": "Lockdown",
    "cfg-f-media": "Media",
    "cfg-f-mentions": "Mentions",
    "cfg-f-messages": "Messages",
    "cfg-f-other": "Other notices",
    "cfg-f-pinned": "Pin notices",
    "cfg-f-rulestext": "Rules text",
    "cfg-f-starthour": "Closes at",
    "cfg-f-stickers": "Stickers",
    "cfg-f-timeout": "Timeout",
    "cfg-f-timezone": "Timezone",
    "cfg-f-trustedids": "Trusted user IDs",
    "cfg-f-type": "Type",
    "cfg-f-welcometext": "Welcome text",
    "cfg-f-window": "Window",
    "cfg-opt-allow": "allow",
    "cfg-opt-ban": "ban",
    "cfg-opt-button": "button",
    "cfg-opt-delete": "delete",
    "cfg-opt-kick": "kick",
    "cfg-opt-math": "math",
    "cfg-opt-mute": "mute",
    "cfg-opt-none": "none",
    "cfg-opt-warn": "warn",
    "cfg-sec-aishield": "AI Shield",
    "cfg-sec-captcha": "Welcome & captcha",
    "cfg-sec-cleanup": "Cleanup",
    "cfg-sec-filters": "Filters",
    "cfg-sec-flood": "Anti-flood",
    "cfg-sec-locks": "Locks",
    "cfg-sec-nightmode": "Night mode",
    "cfg-sec-raid": "Anti-raid",
    "cfg-sec-rules": "Rules",
    "cfg-sec-trusted": "Trusted",
    "cfg-sec-warns": "Warns",
    "cfg-v-never": "never",
    "cfg-v-off": "off",
    "dev-active-groups": "Active groups",
    "dev-ai-active-in": "Active in",
    "dev-ai-body": "AI Shield across all groups: where it is on, how many flags it recorded today and over the last 7 days, and how many checks each group used today against its own cap. The daily counter follows the UTC day.",
    "dev-ai-disarmed": "External AI service not configured: the per-group toggles are inert",
    "dev-budget-hint": "AI checks used today / cap (UTC day)",
    "dev-channels-title": "Channels",
    "dev-chat-help": "One group in detail: which features are on, what Telegram answers when asked right now, and the activity counts. Read-only — nothing here changes anything.",
    "dev-coverage-hint": "Coverage today — checked / checkable · messages seen",
    "dev-detail-error": "Load failed",
    "dev-err-load": "Couldn't load the console.",
    "dev-flags-7d": "Flags (7 days)",
    "dev-flags-today": "Flags today",
    "dev-former-title": "No longer present",
    "dev-groups-body": "Every group the bot lives in, with its armed defenses (🤖 AI Shield · 👋 captcha · 🌊 anti-flood · 🛡️ anti-raid · 🌙 night · 🔇 silent · 📡 log channel). Tap a group for its detail: a live Telegram check, defenses and moderation activity.",
    "dev-groups-empty": "No active groups",
    "dev-groups-title": "Groups",
    "dev-last-known": "last known state",
    "dev-live-night": "night mode active",
    "dev-live-raid": "anti-raid lockdown active",
    "dev-off": "OFF",
    "dev-on": "ON",
    "dev-open-dashboard": "Open this group's dashboard",
    "dev-probe-bot": "Bot status (live)",
    "dev-probe-failed": "failed: Telegram state not confirmed",
    "dev-probe-loading": "running…",
    "dev-probe-members": "Members",
    "dev-probe-title": "Live check",
    "dev-status-body": "The live service picture: whether the dependencies answer, how many groups are active, and any ongoing anomalies — anti-raid lockdowns, active night closures, groups where the bot no longer appears to be an administrator. Group states are the last observed ones: the live check happens when you open a group's detail.",
    "dev-status-degraded": "Service degraded",
    "dev-status-ok": "Service up",
    "dev-status-title": "Status",
    "dev-title": "TurBOT — Console",
    "lang-en": "English",
    "lang-it": "Italiano",
    "stats-row-ban": "Bans",
    "stats-row-config": "Settings changes",
    "stats-row-filter": "Filtered",
    "stats-row-flood": "Flood removed",
    "stats-row-kick": "Kicks",
    "stats-row-lockdown": "Night/raid locks",
    "stats-row-mute": "Mutes",
    "stats-row-other": "Other",
    "stats-row-warn": "Warnings",
    "ui-about": "About",
    "ui-aishield-flags-caption": "Individual flags — last 30 days, newest first.",
    "ui-aishield-flags-erased": "Removed user",
    "ui-aishield-flags-error": "Couldn’t load the events. Close and re-open to retry.",
    "ui-aishield-flags-help": "Each line is one flag: who was flagged, when, of what kind, and how sure the AI was (as a percentage). If the message is still reachable you get “open message”, and below it a quote of the start of the flagged text. If someone is flagged unfairly — common with a group’s own service bots — tap “Trust this person”: from then on they are exempt from the automatic checks and stop appearing here. The exemption is removed from the same place.",
    "ui-aishield-flags-more": "Load more",
    "ui-aishield-flags-open": "open message",
    "ui-aishield-flags-someone": "This person",
    "ui-aishield-flags-trust": "Trust this person",
    "ui-aishield-flags-trust-error": "Couldn’t update the trusted list. Try again.",
    "ui-aishield-flags-trust-full": "The trusted list is full: remove someone before adding.",
    "ui-aishield-flags-trust-no": "Cancel",
    "ui-aishield-flags-trust-warn": "will no longer be checked by AI Shield, anti-flood or the content filters.",
    "ui-aishield-flags-trust-yes": "Confirm",
    "ui-aishield-flags-trusted-badge": "✓ On the trusted list",
    "ui-aishield-flags-untrust": "Remove from trusted",
    "ui-aishield-results-caption": "Suspected spam flagged (shadow mode) — last 7 days (30 days)",
    "ui-aishield-results-empty": "No suspected spam flagged yet.",
    "ui-aishield-results-error": "Couldn’t load AI Shield activity. Re-open the dashboard to retry.",
    "ui-aishield-results-help": "How many times AI Shield flagged a message as suspicious, broken down by kind of suspicion. These are flags only: in shadow mode the bot deletes nothing and blocks nobody — it watches and records. Tap a row to see the individual flags, one by one.",
    "ui-aishield-results-title": "AI Shield activity",
    "ui-aishield-results-total": "Total",
    "ui-bad-domain": "Not a valid domain:",
    "ui-bad-userid": "Not a valid user ID:",
    "ui-editor-help": "Type the text here and tap Save. In lists, put one entry per line: blank lines and duplicates are ignored. To empty a list, delete everything and save. If you close without saving, what you typed is saved anyway.",
    "ui-entry-too-long": "This entry is too long:",
    "ui-err-bad-chat": "I can’t see that group — make sure TurBOT is still a member, then re-open from /dashboard.",
    "ui-err-bad-request": "That request was malformed — nothing was changed.",
    "ui-err-forbidden": "You don't come up as an admin of this group. If you were just made one, close and reopen the dashboard: I re-read permissions on every open.",
    "ui-err-invalid": "That value was rejected — nothing was changed.",
    "ui-err-load": "Couldn’t load this group’s settings.",
    "ui-err-network": "Couldn’t reach TurBOT (network or server error). Please try again.",
    "ui-err-no-chat": "I couldn't open the group picker. Close and reopen the dashboard; if that isn't enough, run /dashboard inside your group and tap the button there.",
    "ui-err-no-initdata": "Telegram didn't send me a sign-in token: a known Telegram Desktop limitation. You have two roads. Open the dashboard from the mobile app — or, if you're staying at your computer, type /config inside your group: it's the same panel, with buttons, and it works here too.",
    "ui-err-not-telegram": "Open this dashboard from Telegram — tap “Open dashboard” in your group’s /dashboard message.",
    "ui-err-rate-limited": "Too many requests right now — wait a minute, then try again.",
    "ui-err-unauthorized": "Your session expired or is invalid. Close and re-open the dashboard from your group.",
    "ui-error-close": "Dismiss the alert",
    "ui-help-close": "Close",
    "ui-help-params-title": "What each option does",
    "ui-language": "Language",
    "ui-list-hint": "One per line",
    "ui-logchannel-body": "When set, TurBOT copies to the chosen chat the moderation actions it records — warns, mutes, bans, kicks, anti-raid lockdowns, night closures, AI flags — with people’s names and the reasons. Anyone who can read that chat reads them: pick a group, and all its members do. For a log only the staff reads, pick a private channel with admins only. Bans and mutes say the duration that was set, in the reader’s own time; the night closure and reopening arrive without sound. Not copied: message deletions, settings changes, and the temporary automatic mutes of people joining (during the captcha or a raid). You can pick a chat you are an admin of (in a channel, with the right to post), or your own private chat with TurBOT: TurBOT checks it. TurBOT must be able to post there too: in a channel, add it as an admin with the right to post. Then paste the numeric id here; TurBOT test-posts to it before saving, so a chat it can’t reach is never stored. Use Disable to stop mirroring.",
    "ui-logchannel-current": "Current log channel:",
    "ui-logchannel-disable": "Disable",
    "ui-logchannel-invalid": "That doesn’t look like a channel id. Paste the channel’s numeric id, e.g. -1001234567890.",
    "ui-logchannel-none": "No log channel configured.",
    "ui-logchannel-not-admin": "You can only pick a chat you are an admin of (in a channel, with the right to post), or your own private chat with TurBOT. Nothing was sent and nothing was saved.",
    "ui-logchannel-placeholder": "Channel id, e.g. -1001234567890",
    "ui-logchannel-save": "Save",
    "ui-logchannel-superseded": "The log chat's state changed in the meantime — another choice, even of the same chat, or the group became a supergroup: your choice was not saved. Reopen the dashboard to reload it, then try again.",
    "ui-logchannel-title": "Log channel",
    "ui-logchannel-unreachable": "I couldn’t post to that chat. TurBOT must be able to post there: in a channel it needs to be an admin with the right to post, even if it is already an admin. Then try again.",
    "ui-logchannel-unverifiable": "I can’t verify that chat. TurBOT must be a member of it (in a channel, an admin with the right to post) and you must be one of its admins.",
    "ui-name-hint": "the new member’s name",
    "ui-pick-empty-admin": "If you run a group",
    "ui-pick-empty-lead": "You aren't an admin of any group I'm in.",
    "ui-pick-empty-member": "If you're a member",
    "ui-pick-empty-member-body": "This is fine — there's nothing here for you. In the group you can use /rules, which shows the group rules, and /report, which flags a message to the admins.",
    "ui-pick-empty-step-1": "Add me to your group",
    "ui-pick-empty-step-2": "Make me an admin",
    "ui-pick-empty-step-3": "Come back and reopen this screen",
    "ui-pick-empty-title": "No groups to configure",
    "ui-pick-failed": "I couldn't check which groups you administer. That doesn't mean you have none — it means the check didn't go through. Try again shortly.",
    "ui-pick-loading": "Loading your groups…",
    "ui-pick-owner-id": "Group id (e.g. -1001234567890)",
    "ui-pick-owner-id-invalid": "That's not a group id: it starts with a minus sign and has only digits.",
    "ui-pick-owner-note": "These are the groups TurBOT has on record. Telegram gives no complete list: a group the bot joined without the event reaching it does not show here. If you know its id, open it below.",
    "ui-pick-owner-open": "Open",
    "ui-pick-partial": "Incomplete list: some groups are missing. Reopen to try again; if one is still missing, open it with /dashboard from inside that group.",
    "ui-pick-retry": "Try again",
    "ui-pick-title": "Choose the group to configure",
    "ui-save": "Save",
    "ui-saved": "Saved ✓",
    "ui-saving": "Saving…",
    "ui-sec-general": "General",
    "ui-sec-general-body": "Group-wide preferences. Language: the language TurBOT writes in for this group — and the language of this dashboard. Silent mode: when it's on, TurBOT keeps moderating exactly as configured — it just won't post the per-action confirmations in the group (for example “muted”, “banned”, or “warn limit reached”). Errors, command help, and the welcome/captcha check are always shown.",
    "ui-silent-title": "Silent mode",
    "ui-stats-body": "TurBOT’s moderation activity in this group, counted from its audit log: each row shows the last 7 days, with the last 30 days in parentheses. It counts automatic work too — flood and filter removals, night-mode and anti-raid locks — not just manual actions. Read-only; the numbers refresh each time you open the dashboard.",
    "ui-stats-caption": "Moderation actions — last 7 days (30 days)",
    "ui-stats-error": "Couldn’t load this group’s statistics. Re-open the dashboard to retry.",
    "ui-stats-month": "Last 30 days",
    "ui-stats-recent": "Last 7 days",
    "ui-stats-title": "Statistics",
    "ui-too-many": "Too many entries."
  },
  "it": {
    "ai-cat-adult": "Contenuti per adulti",
    "ai-cat-crypto": "Cripto",
    "ai-cat-other": "Altro",
    "ai-cat-phishing": "Phishing",
    "ai-cat-promotion": "Promozione",
    "ai-cat-scam": "Truffa",
    "ai-cat-solicitation": "Richieste di contatto",
    "cfg-default": "(predefinito)",
    "cfg-f-action": "Azione",
    "cfg-f-aibudget": "Controlli IA al giorno",
    "cfg-f-allowlist": "Domini consentiti",
    "cfg-f-announce": "Annuncia",
    "cfg-f-blocklist": "Parole bloccate",
    "cfg-f-channels": "Messaggi-canale",
    "cfg-f-cleanprevious": "Pulisci benvenuto precedente",
    "cfg-f-deleteafter": "Elimina dopo",
    "cfg-f-enabled": "Stato",
    "cfg-f-endhour": "Riapre alle",
    "cfg-f-expiry": "Scadenza",
    "cfg-f-failaction": "Se fallisce",
    "cfg-f-forwards": "Inoltri",
    "cfg-f-goodbyetext": "Testo di addio",
    "cfg-f-invites": "Link d’invito",
    "cfg-f-joinleave": "Ingressi / uscite",
    "cfg-f-jointhreshold": "Soglia ingressi",
    "cfg-f-limit": "Limite",
    "cfg-f-linkpolicy": "Policy link",
    "cfg-f-links": "Link",
    "cfg-f-lockdown": "Blocco",
    "cfg-f-media": "Media",
    "cfg-f-mentions": "Menzioni",
    "cfg-f-messages": "Messaggi",
    "cfg-f-other": "Altri avvisi",
    "cfg-f-pinned": "Avvisi fissaggio",
    "cfg-f-rulestext": "Testo delle regole",
    "cfg-f-starthour": "Chiude alle",
    "cfg-f-stickers": "Sticker",
    "cfg-f-timeout": "Timeout",
    "cfg-f-timezone": "Fuso orario",
    "cfg-f-trustedids": "ID utenti fidati",
    "cfg-f-type": "Tipo",
    "cfg-f-welcometext": "Testo di benvenuto",
    "cfg-f-window": "Finestra",
    "cfg-opt-allow": "consentito",
    "cfg-opt-ban": "ban",
    "cfg-opt-button": "pulsante",
    "cfg-opt-delete": "eliminazione",
    "cfg-opt-kick": "espulsione",
    "cfg-opt-math": "matematico",
    "cfg-opt-mute": "silenziamento",
    "cfg-opt-none": "nessuno",
    "cfg-opt-warn": "avviso",
    "cfg-sec-aishield": "AI Shield",
    "cfg-sec-captcha": "Benvenuto e captcha",
    "cfg-sec-cleanup": "Pulizia",
    "cfg-sec-filters": "Filtri",
    "cfg-sec-flood": "Anti-flood",
    "cfg-sec-locks": "Blocchi",
    "cfg-sec-nightmode": "Modalità notturna",
    "cfg-sec-raid": "Anti-raid",
    "cfg-sec-rules": "Regole",
    "cfg-sec-trusted": "Fidati",
    "cfg-sec-warns": "Avvertimenti",
    "cfg-v-never": "mai",
    "cfg-v-off": "off",
    "dev-active-groups": "Gruppi attivi",
    "dev-ai-active-in": "Attivo in",
    "dev-ai-body": "Il quadro di AI Shield su tutti i gruppi: dove è acceso, quante segnalazioni ha registrato oggi e negli ultimi 7 giorni, e quanti controlli ha usato oggi ogni gruppo rispetto al proprio tetto. Il conteggio giornaliero segue il giorno UTC, quindi si azzera un paio d'ore dopo la mezzanotte italiana.",
    "dev-ai-disarmed": "Servizio di IA esterno non configurato: i toggle dei gruppi sono inerti",
    "dev-budget-hint": "Controlli IA usati oggi / tetto (giorno UTC)",
    "dev-channels-title": "Canali",
    "dev-chat-help": "Il dettaglio di un gruppo: quali funzioni sono accese, che cosa risponde Telegram interrogato in questo momento, e i numeri di attività. È di sola lettura — da qui non si cambia niente.",
    "dev-coverage-hint": "Copertura oggi — controllati / controllabili · messaggi visti",
    "dev-detail-error": "Caricamento non riuscito",
    "dev-err-load": "Impossibile caricare la console.",
    "dev-flags-7d": "Segnalazioni (7 giorni)",
    "dev-flags-today": "Segnalazioni oggi",
    "dev-former-title": "Non più presente",
    "dev-groups-body": "Ogni gruppo in cui vive il bot, con le difese accese (🤖 AI Shield · 👋 captcha · 🌊 anti-flood · 🛡️ anti-raid · 🌙 notturna · 🔇 silenziosa · 📡 canale log). Tocca un gruppo per il dettaglio: verifica live su Telegram, difese e attività di moderazione.",
    "dev-groups-empty": "Nessun gruppo attivo",
    "dev-groups-title": "Gruppi",
    "dev-last-known": "ultimo stato noto",
    "dev-live-night": "modalità notturna in corso",
    "dev-live-raid": "anti-raid in corso",
    "dev-off": "OFF",
    "dev-on": "ON",
    "dev-open-dashboard": "Apri la dashboard del gruppo",
    "dev-probe-bot": "Stato del bot (live)",
    "dev-probe-failed": "non riuscita: stato Telegram non confermato",
    "dev-probe-loading": "in corso…",
    "dev-probe-members": "Membri",
    "dev-probe-title": "Verifica live",
    "dev-status-body": "Il quadro vivo del servizio: se le dipendenze rispondono, quanti gruppi risultano attivi e le anomalie in corso — blocchi anti-raid, chiusure notturne attive, gruppi dove il bot non risulta più amministratore. Lo stato dei gruppi è l'ultimo osservato: la verifica live avviene aprendo il dettaglio di un gruppo.",
    "dev-status-degraded": "Servizio degradato",
    "dev-status-ok": "Servizio attivo",
    "dev-status-title": "Stato",
    "dev-title": "TurBOT — Console",
    "lang-en": "English",
    "lang-it": "Italiano",
    "stats-row-ban": "Ban",
    "stats-row-config": "Modifiche impostazioni",
    "stats-row-filter": "Filtrati",
    "stats-row-flood": "Flood rimossi",
    "stats-row-kick": "Espulsioni",
    "stats-row-lockdown": "Blocchi notte/raid",
    "stats-row-mute": "Silenziamenti",
    "stats-row-other": "Altro",
    "stats-row-warn": "Ammonizioni",
    "ui-about": "Info",
    "ui-aishield-flags-caption": "Segnalazioni singole — ultimi 30 giorni, dalla più recente.",
    "ui-aishield-flags-erased": "Utente rimosso",
    "ui-aishield-flags-error": "Impossibile caricare gli eventi. Chiudi e riapri per riprovare.",
    "ui-aishield-flags-help": "Ogni riga è una segnalazione: chi è stato segnalato, quando, di che tipo e quanto l’IA era sicura (in percentuale). Se il messaggio è ancora raggiungibile trovi «apri messaggio», e sotto una citazione dell’inizio del testo segnalato. Se una persona viene segnalata a torto — capita spesso con i bot di servizio del gruppo — tocca «Fidati di questa persona»: da quel momento sarà esente dai controlli automatici e smetterà di comparire qui. L’esenzione si toglie dallo stesso punto.",
    "ui-aishield-flags-more": "Carica altri",
    "ui-aishield-flags-open": "apri messaggio",
    "ui-aishield-flags-someone": "Questa persona",
    "ui-aishield-flags-trust": "Fidati di questa persona",
    "ui-aishield-flags-trust-error": "Impossibile aggiornare la lista dei fidati. Riprova.",
    "ui-aishield-flags-trust-full": "La lista dei fidati è piena: togli qualcuno prima di aggiungere.",
    "ui-aishield-flags-trust-no": "Annulla",
    "ui-aishield-flags-trust-warn": "non sarà più controllata da AI Shield, dall’anti-flood e dai filtri sui contenuti.",
    "ui-aishield-flags-trust-yes": "Conferma",
    "ui-aishield-flags-trusted-badge": "✓ Nella lista dei fidati",
    "ui-aishield-flags-untrust": "Togli dai fidati",
    "ui-aishield-results-caption": "Spam sospetto segnalato (modalità shadow) — ultimi 7 giorni (30 giorni)",
    "ui-aishield-results-empty": "Nessuno spam sospetto ancora segnalato.",
    "ui-aishield-results-error": "Impossibile caricare l’attività di AI Shield. Riapri la dashboard per riprovare.",
    "ui-aishield-results-help": "Quante volte AI Shield ha segnalato un messaggio come sospetto, divise per tipo di sospetto. Sono solo segnalazioni: in modalità shadow il bot non cancella e non blocca nessuno: guarda e annota. Tocca una riga per vedere le singole segnalazioni, una per una.",
    "ui-aishield-results-title": "Attività AI Shield",
    "ui-aishield-results-total": "Totale",
    "ui-bad-domain": "Dominio non valido:",
    "ui-bad-userid": "ID utente non valido:",
    "ui-editor-help": "Scrivi qui il testo e tocca Salva. Nelle liste va una voce per riga: righe vuote e duplicati vengono ignorati. Per svuotare la lista, cancella tutto e salva. Chiudendo senza salvare, il testo scritto viene comunque salvato.",
    "ui-entry-too-long": "Voce troppo lunga:",
    "ui-err-bad-chat": "Non riesco a vedere quel gruppo — assicurati che TurBOT ne sia ancora membro, poi riapri da /dashboard.",
    "ui-err-bad-request": "Quella richiesta non era valida — non è stato modificato nulla.",
    "ui-err-forbidden": "Non risulti amministratore di questo gruppo. Se lo sei da poco, chiudi e riapri la dashboard: rileggo i permessi a ogni apertura.",
    "ui-err-invalid": "Quel valore è stato rifiutato — non è stato modificato nulla.",
    "ui-err-load": "Non sono riuscito a caricare le impostazioni di questo gruppo.",
    "ui-err-network": "Non sono riuscito a contattare TurBOT (errore di rete o del server). Riprova.",
    "ui-err-no-chat": "Non sono riuscito ad aprire la scelta del gruppo. Chiudi e riapri la dashboard; se non basta, esegui /dashboard dentro il tuo gruppo e tocca il pulsante lì.",
    "ui-err-no-initdata": "Telegram non mi ha inviato il token di accesso: è una limitazione nota di Telegram Desktop. Hai due strade. Apri la dashboard dall'app per cellulare — oppure, se resti al computer, scrivi /config dentro al tuo gruppo: è lo stesso pannello, a pulsanti, e funziona anche qui.",
    "ui-err-not-telegram": "Apri questa dashboard da Telegram — tocca “Apri la dashboard” nel messaggio /dashboard del tuo gruppo.",
    "ui-err-rate-limited": "Troppe richieste in questo momento — attendi un minuto e riprova.",
    "ui-err-unauthorized": "La tua sessione è scaduta o non è valida. Chiudi e riapri la dashboard dal tuo gruppo.",
    "ui-error-close": "Chiudi l’avviso",
    "ui-help-close": "Chiudi",
    "ui-help-params-title": "Cosa fa ogni opzione",
    "ui-language": "Lingua",
    "ui-list-hint": "Uno per riga",
    "ui-logchannel-body": "Quando è impostato, TurBOT copia sulla chat scelta le azioni di moderazione che registra — avvertimenti, silenziamenti, ban, espulsioni, blocchi anti-raid, chiusure notturne, segnalazioni dell’IA — con i nomi delle persone e i motivi. Li legge chiunque possa leggere quella chat: se scegli un gruppo, tutti i suoi membri. Per un registro che legga solo lo staff, scegli un canale privato con soli amministratori. Ban e silenziamenti dicono la durata impostata, nell’ora di chi legge; la chiusura e la riapertura notturne arrivano senza suono. Non arrivano le cancellazioni dei messaggi, le modifiche alle impostazioni e i silenziamenti temporanei automatici di chi entra (durante il captcha o un raid). Puoi scegliere una chat di cui sei amministratore (in un canale, col diritto di pubblicare), oppure la tua chat privata con TurBOT: TurBOT lo verifica. Anche TurBOT deve poterci scrivere: in un canale, aggiungilo come amministratore col diritto di pubblicare. Poi incolla qui l’id numerico; TurBOT invia un messaggio di prova prima di salvare, così una chat che non riesce a raggiungere non viene mai memorizzata. Usa Disattiva per interrompere la copia.",
    "ui-logchannel-current": "Canale dei log attuale:",
    "ui-logchannel-disable": "Disattiva",
    "ui-logchannel-invalid": "Non sembra un id di canale. Incolla l’id numerico del canale, es. -1001234567890.",
    "ui-logchannel-none": "Nessun canale dei log configurato.",
    "ui-logchannel-not-admin": "Puoi scegliere solo una chat di cui sei amministratore (in un canale, col diritto di pubblicare), oppure la tua chat privata con TurBOT. Non ho inviato niente e non ho salvato niente.",
    "ui-logchannel-placeholder": "Id del canale, es. -1001234567890",
    "ui-logchannel-save": "Salva",
    "ui-logchannel-superseded": "Nel frattempo lo stato della chat dei log è cambiato — un'altra scelta, anche della stessa chat, oppure il gruppo è diventato un supergruppo: non ho salvato la tua scelta. Riapri la dashboard per ricaricarlo, poi riprova.",
    "ui-logchannel-title": "Canale dei log",
    "ui-logchannel-unreachable": "Non riesco a scrivere su quella chat. TurBOT deve poterci pubblicare: in un canale serve che sia amministratore col diritto di pubblicare, anche se è già amministratore. Poi riprova.",
    "ui-logchannel-unverifiable": "Non riesco a verificare quella chat. TurBOT deve esserne membro (in un canale, amministratore col diritto di pubblicare) e tu devi esserne amministratore.",
    "ui-name-hint": "il nome del nuovo membro",
    "ui-pick-empty-admin": "Se amministri un gruppo",
    "ui-pick-empty-lead": "Non risulti amministratore di nessun gruppo in cui io sia presente.",
    "ui-pick-empty-member": "Se sei un membro",
    "ui-pick-empty-member-body": "Va bene così: da qui non ti serve nulla. Nel gruppo puoi usare /rules, che mostra il regolamento, e /report, che segnala un messaggio agli amministratori.",
    "ui-pick-empty-step-1": "Aggiungimi al tuo gruppo",
    "ui-pick-empty-step-2": "Nominami amministratore",
    "ui-pick-empty-step-3": "Torna qui e riapri questa schermata",
    "ui-pick-empty-title": "Nessun gruppo da configurare",
    "ui-pick-failed": "Non sono riuscito a controllare quali gruppi amministri. Non vuol dire che non ne hai: vuol dire che la verifica non è andata a buon fine. Riprova fra poco.",
    "ui-pick-loading": "Carico i tuoi gruppi…",
    "ui-pick-owner-id": "Id del gruppo (es. -1001234567890)",
    "ui-pick-owner-id-invalid": "Non è l'id di un gruppo: comincia con il segno meno ed è fatto di sole cifre.",
    "ui-pick-owner-note": "Questi sono i gruppi che TurBOT ha registrato. Telegram non dà un elenco completo: un gruppo dove il bot è entrato senza che l'evento arrivasse qui non compare. Se ne conosci l'id, aprilo qui sotto.",
    "ui-pick-owner-open": "Apri",
    "ui-pick-partial": "Elenco incompleto: qualche gruppo non compare. Riapri per riprovare; se manca ancora, aprilo con /dashboard da dentro quel gruppo.",
    "ui-pick-retry": "Riprova",
    "ui-pick-title": "Scegli il gruppo da configurare",
    "ui-save": "Salva",
    "ui-saved": "Salvato ✓",
    "ui-saving": "Salvataggio…",
    "ui-sec-general": "Generali",
    "ui-sec-general-body": "Preferenze a livello di gruppo. Lingua: la lingua in cui TurBOT scrive in questo gruppo — ed è anche la lingua di questa dashboard. Modalità silenziosa: quando è attiva, TurBOT continua a moderare esattamente come configurato — semplicemente non pubblica più le conferme delle singole azioni nel gruppo (per esempio “silenziato”, “bannato” o “limite di avvertimenti raggiunto”). Errori, aiuto sui comandi e la verifica di benvenuto/captcha vengono sempre mostrati.",
    "ui-silent-title": "Modalità silenziosa",
    "ui-stats-body": "L’attività di moderazione di TurBOT in questo gruppo, contata dal suo registro (audit log): ogni riga mostra gli ultimi 7 giorni, con gli ultimi 30 giorni tra parentesi. Conta anche il lavoro automatico — rimozioni per flood e filtri, blocchi notturni e anti-raid — non solo le azioni manuali. Sola lettura; i numeri si aggiornano a ogni apertura della dashboard.",
    "ui-stats-caption": "Azioni di moderazione — ultimi 7 giorni (30 giorni)",
    "ui-stats-error": "Impossibile caricare le statistiche del gruppo. Riapri la dashboard per riprovare.",
    "ui-stats-month": "Ultimi 30 giorni",
    "ui-stats-recent": "Ultimi 7 giorni",
    "ui-stats-title": "Statistiche",
    "ui-too-many": "Troppe voci."
  }
}
